// import React, { useState } from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   CircularProgress,
// } from "@mui/material";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import axios from "axios";
// import ReplayIcon from "@mui/icons-material/Replay";
// import { API_BASE_URL } from "../../config";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";
// import { useTranslation } from "react-i18next";

// export const OtpPage = ({ email, mobile_number, onOtpVerified }) => {
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);
//   const [resendLoading, setResendLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     severity: "success",
//     message: "",
//   });

//   const formik = useFormik({
//     initialValues: {
//       email: email || "",
//       mobile_number: mobile_number || "",
//       otp: "",
//     },
//     validationSchema: Yup.object({
//       otp: Yup.string()
//         .matches(/^\d{6}$/, t("otp.errors.invalidFormat")) // "OTP must be 6 digits"
//         .required(t("otp.errors.required")),               // "OTP is required"
//     }),
//     onSubmit: async (values) => {
//       setLoading(true);
//       try {
//         await axios.post(
//           `${API_BASE_URL}/auth/verify/`,
//           {
//             email: values.email,
//             otp: values.otp,
//           },
//           { headers: { "Content-Type": "application/json" } }
//         );
//         setSnackbar({
//           open: true,
//           severity: "success",
//           message: t("otp.success"), // "OTP verified successfully!"
//         });
//         if (onOtpVerified) onOtpVerified();
//       } catch (error) {
//         let errorMsg = t("otp.errors.verificationFailed");
//         if (error.response?.data) {
//           errorMsg = JSON.stringify(error.response.data);
//         }
//         setSnackbar({
//           open: true,
//           severity: "error",
//           message: errorMsg,
//         });
//       } finally {
//         setLoading(false);
//       }
//     },
//   });

//   const handleResendOtp = async () => {
//     setResendLoading(true);
//     try {
//       await axios.post(
//         `${API_BASE_URL}/auth/resend-otp/`,
//         { email },
//         { headers: { "Content-Type": "application/json" } }
//       );
//       setSnackbar({
//         open: true,
//         severity: "success",
//         message: t("otp.resent"), // "OTP resent successfully!"
//       });
//     } catch (error) {
//       let errorMsg = t("otp.errors.resendFailed");
//       if (error.response?.data) {
//         errorMsg = JSON.stringify(error.response.data);
//       }
//       setSnackbar({
//         open: true,
//         severity: "error",
//         message: errorMsg,
//       });
//     } finally {
//       setResendLoading(false);
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar((prev) => ({ ...prev, open: false }));
//   };

//   return (
//     <Box sx={{ position: "relative" }}>
//       {/* Top right resend button */}
//       <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
//         <Button
//           size="small"
//           variant="text"
//           endIcon={resendLoading ? <CircularProgress size={16} /> : <ReplayIcon />}
//           onClick={handleResendOtp}
//           disabled={resendLoading}
//         >
//           {t("otp.resendBtn")}
//         </Button>
//       </Box>

//       <Typography variant="h6" align="center" gutterBottom>
//         {t("otp.instruction")} 
//       </Typography>

//       <Box
//         component="form"
//         onSubmit={formik.handleSubmit}
//         sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}
//       >
//         <TextField
//           label={t("otp.fields.email")}
//           name="email"
//           value={formik.values.email}
//           disabled
//           size="small"
//           fullWidth
//         />
//         <TextField
//           label={t("otp.fields.phone")}
//           name="mobile_number"
//           value={formik.values.mobile_number}
//           disabled
//           size="small"
//           fullWidth
//         />
//         <TextField
//           label={t("otp.fields.otp")}
//           name="otp"
//           value={formik.values.otp}
//           onChange={formik.handleChange}
//           onBlur={formik.handleBlur}
//           error={formik.touched.otp && Boolean(formik.errors.otp)}
//           helperText={formik.touched.otp && formik.errors.otp}
//           fullWidth
//           size="small"
//           inputProps={{ maxLength: 6 }}
//         />
//         <Button
//           type="submit"
//           variant="contained"
//           color="primary"
//           fullWidth
//           disabled={loading}
//           startIcon={loading ? <CircularProgress size={20} /> : null}
//         >
//           {loading ? t("otp.buttons.verifying") : t("otp.buttons.verify")}
//         </Button>
//       </Box>

//       {/* Custom Snackbar */}
//       <SnackBarComponent
//         open={snackbar.open}
//         severity={snackbar.severity}
//         message={snackbar.message}
//         onClose={handleCloseSnackbar}
//       />
//     </Box>
//   );
// };



// import React, { useState } from "react";
// import {
//   Box,
//   TextField,
//   Button,
//   Typography,
//   CircularProgress,
// } from "@mui/material";
// import { useFormik } from "formik";
// import * as Yup from "yup";
// import axios from "axios";
// import ReplayIcon from "@mui/icons-material/Replay";
// import { API_BASE_URL } from "../../config";
// import { SnackBarComponent } from "../../Components/snackBar/snackBar";
// import { useTranslation } from "react-i18next";

// export const OtpPage = ({ email, mobile_number, onOtpVerified }) => {
//   const { t } = useTranslation();
//   const [loading, setLoading] = useState(false);
//   const [resendLoading, setResendLoading] = useState(false);
//   const [snackbar, setSnackbar] = useState({
//     open: false,
//     severity: "success",
//     message: "",
//   });

//   const formik = useFormik({
//     initialValues: {
//       email: email || "",
//       mobile_number: mobile_number || "",
//       otp: "",
//       mobile_otp: "",
//     },
//     validationSchema: Yup.object({
//       otp: Yup.string()
//         .matches(/^\d{6}$/, t("otp.errors.invalidFormat"))
//         .required(t("otp.errors.required")),
//       mobile_otp: Yup.string()
//         .matches(/^\d{6}$/, t("otp.errors.invalidMobileFormat"))
//         .required(t("otp.errors.mobileRequired")),
//     }),
//     onSubmit: async (values) => {
//       setLoading(true);
//       try {
//         await axios.post(
//           `${API_BASE_URL}/auth/verify/`,
//           {
//             email: values.email,
//             otp: values.otp,
//             mobile_otp: values.mobile_otp,
//           },
//           { headers: { "Content-Type": "application/json" } }
//         );
//         setSnackbar({
//           open: true,
//           severity: "success",
//           message: t("otp.success"),
//         });
//         if (onOtpVerified) onOtpVerified();
//       } catch (error) {
//         let errorMsg = t("otp.errors.verificationFailed");
//         if (error.response?.data) {
//           errorMsg = JSON.stringify(error.response.data);
//         }
//         setSnackbar({
//           open: true,
//           severity: "error",
//           message: errorMsg,
//         });
//       } finally {
//         setLoading(false);
//       }
//     },
//   });

//   const handleResendOtp = async () => {
//     setResendLoading(true);
//     try {
//       await axios.post(
//         `${API_BASE_URL}/auth/resend-otp/`,
//         { email },
//         { headers: { "Content-Type": "application/json" } }
//       );
//       setSnackbar({
//         open: true,
//         severity: "success",
//         message: t("otp.resent"),
//       });
//     } catch (error) {
//       let errorMsg = t("otp.errors.resendFailed");
//       if (error.response?.data) {
//         errorMsg = JSON.stringify(error.response.data);
//       }
//       setSnackbar({
//         open: true,
//         severity: "error",
//         message: errorMsg,
//       });
//     } finally {
//       setResendLoading(false);
//     }
//   };

//   const handleCloseSnackbar = () => {
//     setSnackbar((prev) => ({ ...prev, open: false }));
//   };

//   return (
//     <Box sx={{ position: "relative" }}>
//       {/* Top right resend button */}
//       <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
//         <Button
//           size="small"
//           variant="text"
//           endIcon={resendLoading ? <CircularProgress size={16} /> : <ReplayIcon />}
//           onClick={handleResendOtp}
//           disabled={resendLoading}
//         >
//           {t("otp.resendBtn")}
//         </Button>
//       </Box>

//       <Typography variant="h6" align="center" gutterBottom>
//         {t("otp.instruction")}
//       </Typography>

//       <Box
//         component="form"
//         onSubmit={formik.handleSubmit}
//         sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}
//       >
//         <TextField
//           label={t("otp.fields.email")}
//           name="email"
//           value={formik.values.email}
//           disabled
//           size="small"
//           fullWidth
//         />
//         <TextField
//           label={t("otp.fields.phone")}
//           name="mobile_number"
//           value={formik.values.mobile_number}
//           disabled
//           size="small"
//           fullWidth
//         />
//         <TextField
//           label={t("otp.fields.otp")}
//           name="otp"
//           value={formik.values.otp}
//           onChange={formik.handleChange}
//           onBlur={formik.handleBlur}
//           error={formik.touched.otp && Boolean(formik.errors.otp)}
//           helperText={formik.touched.otp && formik.errors.otp}
//           fullWidth
//           size="small"
//           inputProps={{ maxLength: 6 }}
//         />
//         <TextField
//           label={t("otp.fields.mobileOtp")}
//           name="mobile_otp"
//           value={formik.values.mobile_otp}
//           onChange={formik.handleChange}
//           onBlur={formik.handleBlur}
//           error={formik.touched.mobile_otp && Boolean(formik.errors.mobile_otp)}
//           helperText={formik.touched.mobile_otp && formik.errors.mobile_otp}
//           fullWidth
//           size="small"
//           inputProps={{ maxLength: 6 }}
//         />
//         <Button
//           type="submit"
//           variant="contained"
//           color="primary"
//           fullWidth
//           disabled={loading}
//           startIcon={loading ? <CircularProgress size={20} /> : null}
//         >
//           {loading ? t("otp.buttons.verifying") : t("otp.buttons.verify")}
//         </Button>
//       </Box>

//       {/* Custom Snackbar */}
//       <SnackBarComponent
//         open={snackbar.open}
//         severity={snackbar.severity}
//         message={snackbar.message}
//         onClose={handleCloseSnackbar}
//       />
//     </Box>
//   );
// };



import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  CircularProgress,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import ReplayIcon from "@mui/icons-material/Replay";
import { API_BASE_URL } from "../../config";
import { SnackBarComponent } from "../../Components/snackBar/snackBar";
import { useTranslation } from "react-i18next";

export const OtpPage = ({ email, mobile_number, onOtpVerified }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({
    open: false,
    severity: "success",
    message: "",
  });

  const formik = useFormik({
    initialValues: {
      email: email || "",
      mobile_number: mobile_number || "",
      otp: "",
      mobile_otp: "",
    },
    validationSchema: Yup.object({
      otp: Yup.string()
        .matches(/^\d{6}$/, t("otp.errors.invalidFormat"))
        .required(t("otp.errors.required")),
      mobile_otp: Yup.string()
        .matches(/^\d{6}$/, t("otp.errors.invalidMobileFormat"))
        .required(t("otp.errors.mobileRequired")),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      try {
        await axios.post(
          `${API_BASE_URL}/auth/verify/`,
          {
            email: values.email,
            otp: values.otp,
            mobile_otp: values.mobile_otp,
          },
          { headers: { "Content-Type": "application/json" } }
        );
        
        // Show success snackbar first
        setSnackbar({
          open: true,
          severity: "success",
          message: t("otp.success"),
        });
        
        // Delay navigation to allow snackbar to show
        setTimeout(() => {
          if (onOtpVerified) {
            onOtpVerified();
          }
        }, 1500); // 1.5 seconds - matches typical snackbar duration
        
      } catch (error) {
        let errorMsg = t("otp.errors.verificationFailed");
        if (error.response?.data) {
          errorMsg = JSON.stringify(error.response.data);
        }
        setSnackbar({
          open: true,
          severity: "error",
          message: errorMsg,
        });
      } finally {
        setLoading(false);
      }
    },
  });

  const handleResendOtp = async () => {
    setResendLoading(true);
    try {
      await axios.post(
        `${API_BASE_URL}/auth/resend-otp/`,
        { email },
        { headers: { "Content-Type": "application/json" } }
      );
      setSnackbar({
        open: true,
        severity: "success",
        message: t("otp.resent"),
      });
    } catch (error) {
      let errorMsg = t("otp.errors.resendFailed");
      if (error.response?.data) {
        errorMsg = JSON.stringify(error.response.data);
      }
      setSnackbar({
        open: true,
        severity: "error",
        message: errorMsg,
      });
    } finally {
      setResendLoading(false);
    }
  };

  const handleCloseSnackbar = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  return (
    <Box sx={{ position: "relative" }}>
      {/* Top right resend button */}
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 1 }}>
        <Button
          size="small"
          variant="text"
          endIcon={resendLoading ? <CircularProgress size={16} /> : <ReplayIcon />}
          onClick={handleResendOtp}
          disabled={resendLoading}
        >
          {t("otp.resendBtn")}
        </Button>
      </Box>

      <Typography variant="h6" align="center" gutterBottom>
        {t("otp.instruction")}
      </Typography>

      <Box
        component="form"
        onSubmit={formik.handleSubmit}
        sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}
      >
        <TextField
          label={t("otp.fields.email")}
          name="email"
          value={formik.values.email}
          disabled
          size="small"
          fullWidth
        />
        <TextField
          label={t("otp.fields.phone")}
          name="mobile_number"
          value={formik.values.mobile_number}
          disabled
          size="small"
          fullWidth
        />
        <TextField
          label={t("otp.fields.otp")}
          name="otp"
          value={formik.values.otp}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.otp && Boolean(formik.errors.otp)}
          helperText={formik.touched.otp && formik.errors.otp}
          fullWidth
          size="small"
          inputProps={{ maxLength: 6 }}
        />
        <TextField
          label={t("otp.fields.mobileOtp")}
          name="mobile_otp"
          value={formik.values.mobile_otp}
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          error={formik.touched.mobile_otp && Boolean(formik.errors.mobile_otp)}
          helperText={formik.touched.mobile_otp && formik.errors.mobile_otp}
          fullWidth
          size="small"
          inputProps={{ maxLength: 6 }}
        />
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          disabled={loading}
          startIcon={loading ? <CircularProgress size={20} /> : null}
        >
          {loading ? t("otp.buttons.verifying") : t("otp.buttons.verify")}
        </Button>
      </Box>

      {/* Custom Snackbar */}
      <SnackBarComponent
        open={snackbar.open}
        severity={snackbar.severity}
        message={snackbar.message}
        onClose={handleCloseSnackbar}
      />
    </Box>
  );
};
